import { Box, styled } from "@mui/material";
import { useDrop, DropTargetMonitor } from "react-dnd";
import { useDispatch } from "react-redux";
import { IFlight } from "@vmosolutions/oc-interfaces";
import _ from "lodash";
import { getEventsByFlight } from "src/redux/reducers/OpsLinkReducer";

export interface IFlightDropCard {
  id?: string;
  trackedFlights: IFlight[];
  setTrackedFlights: React.Dispatch<React.SetStateAction<IFlight[]>>;
  selectedFlights: IFlight[];
  setSelectedFlights: React.Dispatch<React.SetStateAction<IFlight[]>>;
}

const OCFlightDropCard = styled(Box)(({ theme }) => ({
  userSelect: "none",
  width: "170px",
  height: "90px",
  padding: "5px 10px",
  fontFamily: "B612 Mono, arial, sans-serif",
  fontSize: 10,
  fontWeight: "normal",
  display: "grid",
  alignItems: "center",
  justifyContent: "center",
  border: "2px dashed green",
}));

export const FlightDropCard = (props: IFlightDropCard): JSX.Element => {
  const { id, trackedFlights, setTrackedFlights, selectedFlights, setSelectedFlights } = props;
  const dispatch = useDispatch();

  const [{ isOver }, drop] = useDrop({
    accept: ["FLIGHT", "SELECTED_FLIGHTS", "FLIGHTS"],
    drop(item: any, monitor: DropTargetMonitor) {
      let newFlights: IFlight[] = [];
      switch (item.type) {
        case "FLIGHT":
          newFlights = [item.flight];
          break;
        case "SELECTED_FLIGHTS":
          newFlights = item.selectedFlights;
          break;
        case "FLIGHTS":
          newFlights = item.flights;
          break;
        default:
          break;
      }
      if (newFlights.length > 0) {
        const groupedFlights = [...trackedFlights, ...newFlights];
        const uniqueFlights = _.uniqBy(groupedFlights, _.iteratee("_id"));
        setTrackedFlights(uniqueFlights);
        setSelectedFlights(uniqueFlights);
        uniqueFlights.forEach((flight) => {
          dispatch(getEventsByFlight({ flightId: flight._id }));
        });
      }
    },
    collect(monitor: DropTargetMonitor) {
      return {
        isOver: monitor.isOver(),
      };
    },
  });

  return <OCFlightDropCard ref={drop}>Drag Flight Chip</OCFlightDropCard>;
};
